"use client";
import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import YouTubeEmbed from "./youtube-embed";
import Image from "next/image";
import CtaContact from "./cta-contact";

export default function SystemDescription({ services }) {
  return (
    <>
      {services.map((service) => (
        <div key={service.id}>
          <div
            className="flex flex-col lg:flex-row justify-center lg:justify-between border rounded-md"
            data-aos="fade-left"
          >
            <div
              className={`lg:w-1/2 w-full max-h-[400px] ${
                service.videoUrl || service.image ? "flex" : "hidden"
              }`}
            >
              {service.videoUrl ? (
                <YouTubeEmbed videoId={service.videoUrl} />
              ) : service.image ? (
                <Image
                  src={service.image}
                  height={500}
                  width={500}
                  // fill={true}
                  className="w-full rounded-t-lg rounded-lb-none md:rounded-tr-none md:rounded-l-lg md:h-full object-cover "
                  alt="Image"
                />
              ) : null}
            </div>

            <div
              className={`flex flex-col justify-center text-center md:text-start md:justify-start w-full px-8 md:mx-5 py-5 ${
                service.videoUrl || service.image ? "lg:w-1/2" : "lg:w-full"
              }`}
            >
              <h1 className="text-xl font-normal text-blue-500 pb-2">
                {service.service}
              </h1>
              <div className="font-thin text-sm overflow-y-scroll max-h-[200px] pr-2">
                {service.description}
              </div>
            </div>
          </div>

          <div
            className="flex flex-col justify-start w-full py-10"
            data-aos="fade-up"
          >
            <ExpandableItems descriptionItems={service.descriptionItems} />
          </div>
          <div className="py-5 lg:py-10">
            <hr />
          </div>
        </div>
      ))}
      <CtaContact />
    </>
  );
}

function ExpandableItems({ descriptionItems }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxVisibleRows = 1;
  const itemsPerRow = 3;

  // Calculate the maximum number of items to display based on rows
  const maxVisibleItems = maxVisibleRows * itemsPerRow;

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex flex-col">
      <ul
        className={`grid grid-cols-1 lg:grid-cols-3 gap-5 font-thin transition-all duration-300 ${
          isExpanded ? "" : "overflow-hidden"
        }`}
      >
        {descriptionItems
          .slice(0, isExpanded ? descriptionItems.length : maxVisibleItems)
          .map((item) => (
            <div
              className="text-center py-10 px-3 border rounded-md border-blue-500 border-opacity-50 bg-blue-500 bg-opacity-5"
              key={item.id}
            >
              <label className="text-blue-500 font-medium py-5 text-sm">
                {item.descItemTitle}
              </label>
              <li className="text-sm">{item.descItem}</li>
            </div>
          ))}
      </ul>
      {descriptionItems.length > maxVisibleItems && (
        <button
          onClick={toggleExpansion}
          className="flex items-center justify-center mt-10 md:mt-4 text-blue-900 font-medium"
        >
          {isExpanded ? (
            <>
              Show Less <FaChevronUp className="ml-2" />
            </>
          ) : (
            <>
              Show More <FaChevronDown className="ml-2" />
            </>
          )}
        </button>
      )}
    </div>
  );
}
